"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = __importStar(require("prop-types"));
var React = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var core_1 = require("@popperjs/core");
var DayPicker_1 = __importDefault(require("./sub-component/DayPicker"));
var TextField_1 = __importDefault(require("../input/TextField"));
var FontIcon_1 = __importDefault(require("../icon/FontIcon"));
var styled_components_1 = __importDefault(require("styled-components"));
var popperUtils_1 = require("../common/popperUtils");
var matchDayUtils_1 = require("./utils/matchDayUtils");
var eventUtils_1 = require("../common/eventUtils");
var propTypesUtils_1 = require("./utils/propTypesUtils");
var dateUtils_1 = require("./utils/dateUtils");
var date_fns_1 = require("date-fns");
// z-index: 4; equivalent to $z-index-tooltip
var DatePickerContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: 4;\n  &.DatePickerContainer {\n    ", "\n  }\n"], ["\n  z-index: 4;\n  &.DatePickerContainer {\n    ", "\n  }\n"])), popperUtils_1.PopperContainer);
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.refPicker = null;
        _this.dayPickerInstance = null;
        var date = props.date, format = props.format, initialMonth = props.initialMonth, locale = props.locale;
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        var getLocale = require("date-fns/locale/" + (locale || 'en-US') + "/index.js");
        _this.state = {
            navigationDate: initialMonth || _this.computeDate(date) || new Date(),
            locale: getLocale,
            inputValue: _this.computeDate(date)
                ? date_fns_1.format(date, format, { locale: getLocale })
                : null,
            showPicker: false,
            refIcon: react_1.createRef(),
            refContainer: null,
            popperElement: null,
            referenceElement: null,
        };
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.handleDayClick = _this.handleDayClick.bind(_this);
        _this.handleKeyDownIcon = _this.handleKeyDownIcon.bind(_this);
        _this.handleKeyDownInput = _this.handleKeyDownInput.bind(_this);
        _this.handleOnClose = _this.handleOnClose.bind(_this);
        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
        _this.setRefContainer = _this.setRefContainer.bind(_this);
        _this.setPopperElement = _this.setPopperElement.bind(_this);
        _this.setReferenceElement = _this.setReferenceElement.bind(_this);
        _this.mountDayPickerInstance = _this.mountDayPickerInstance.bind(_this);
        _this.unmountDayPickerInstance = _this.unmountDayPickerInstance.bind(_this);
        _this.handleScrollParent = _this.handleScrollParent.bind(_this);
        _this.handleKeydownScrollParent = _this.handleKeydownScrollParent.bind(_this);
        return _this;
    }
    DatePicker.prototype.componentDidMount = function () {
        var _a = this.props, onInit = _a.onInit, date = _a.date;
        document.addEventListener('mousedown', this.handleClickOutside);
        if (this.props.showOverlay && !this.props.menuPortalTarget) { // doesn't open if inside a portal
            this.setState({ showPicker: true });
        }
        if (onInit && date) {
            onInit(this.computeDate(date));
        }
    };
    DatePicker.prototype.componentWillUnmount = function () {
        document.removeEventListener('mousedown', this.handleClickOutside);
    };
    DatePicker.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.showPicker && !prevState.showPicker) {
            this.mountDayPickerInstance();
        }
        else if (!this.state.showPicker && prevState.showPicker) {
            this.unmountDayPickerInstance();
        }
        // update dynamically if locale change
        if (this.props.locale !== prevProps.locale) {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            var getLocale = require("date-fns/locale/" + (this.props.locale || 'en-US') + "/index.js");
            this.setState({
                locale: getLocale,
                inputValue: this.computeDate(this.props.date)
                    ? date_fns_1.format(this.props.date, this.props.format, {
                        locale: getLocale,
                    })
                    : null,
            });
        }
    };
    /**
     * Reset to default value and reset errors
     */
    DatePicker.prototype.reset = function (date) {
        var _a = this.props, format = _a.format, onChange = _a.onChange, onValidationChanged = _a.onValidationChanged;
        var locale = this.state.locale;
        if (onValidationChanged) {
            onValidationChanged(null);
        }
        if (onChange) {
            onChange({ target: { value: date } });
        }
        this.setState({
            inputValue: this.computeDate(date)
                ? date_fns_1.format(date, format, { locale: locale })
                : null,
        });
    };
    DatePicker.prototype.handleClickOutside = function (event) {
        var _a = this.state, popperElement = _a.popperElement, refContainer = _a.refContainer, showPicker = _a.showPicker;
        if (refContainer &&
            !refContainer.contains(event.target) &&
            popperElement &&
            !popperElement.contains(event.target)) {
            var _b = this.props, date = _b.date, onBlur = _b.onBlur;
            if (showPicker) {
                this.setState({ showPicker: false });
                if (onBlur) {
                    onBlur({
                        target: {
                            value: date,
                        },
                    });
                }
            }
        }
    };
    DatePicker.prototype.setRefContainer = function (node) {
        this.setState({ refContainer: node });
    };
    DatePicker.prototype.setPopperElement = function (node) {
        this.setState({ popperElement: node });
    };
    DatePicker.prototype.setReferenceElement = function (node) {
        this.setState({ referenceElement: node });
    };
    DatePicker.prototype.mountDayPickerInstance = function () {
        var _a = this.props, placement = _a.placement, menuShouldBlockScroll = _a.menuShouldBlockScroll;
        var _b = this.state, popperElement = _b.popperElement, referenceElement = _b.referenceElement, refContainer = _b.refContainer;
        this.dayPickerInstance = core_1.createPopper(referenceElement, popperElement, {
            placement: placement + "-start",
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: ['top-start', 'right-start', 'left-start'],
                    },
                },
                {
                    name: 'offset',
                    options: {
                        offset: [0, 4],
                    },
                },
            ],
        });
        if (menuShouldBlockScroll) {
            var scrollContainer = eventUtils_1.getScrollParent(refContainer);
            if (scrollContainer) {
                var wheelEvent = eventUtils_1.EventListener.onwheel in document.createElement('div') ? eventUtils_1.EventListener.wheel : eventUtils_1.EventListener.mousewheel;
                scrollContainer.addEventListener(eventUtils_1.EventListener.DOMMouseScroll, this.handleScrollParent); // older Firefox
                scrollContainer.addEventListener(eventUtils_1.EventListener.touchmove, this.handleScrollParent); // mobile
                scrollContainer.addEventListener(wheelEvent, this.handleScrollParent); // modern desktop
                scrollContainer.addEventListener(eventUtils_1.EventListener.keydown, this.handleKeydownScrollParent);
            }
        }
    };
    DatePicker.prototype.unmountDayPickerInstance = function () {
        var menuShouldBlockScroll = this.props.menuShouldBlockScroll;
        var refContainer = this.state.refContainer;
        if (this.dayPickerInstance) {
            this.dayPickerInstance.destroy();
            Reflect.deleteProperty(this, 'dayPickerInstance');
            if (menuShouldBlockScroll) {
                var scrollContainer = eventUtils_1.getScrollParent(refContainer);
                if (scrollContainer) {
                    var wheelEvent = eventUtils_1.EventListener.onwheel in document.createElement('div') ? eventUtils_1.EventListener.wheel : eventUtils_1.EventListener.mousewheel;
                    scrollContainer.removeEventListener(eventUtils_1.EventListener.DOMMouseScroll, this.handleScrollParent);
                    scrollContainer.removeEventListener(eventUtils_1.EventListener.touchmove, this.handleScrollParent);
                    scrollContainer.removeEventListener(wheelEvent, this.handleScrollParent);
                    scrollContainer.removeEventListener(eventUtils_1.EventListener.keydown, this.handleKeydownScrollParent);
                }
            }
        }
    };
    DatePicker.prototype.computeDate = function (date) {
        var disabledDays = this.props.disabledDays;
        if (date && date_fns_1.isValid(date) && !matchDayUtils_1.matchDay(date, disabledDays)) {
            return date;
        }
        else {
            return null;
        }
    };
    DatePicker.prototype.computeError = function (date) {
        var disabledDays = this.props.disabledDays;
        if (!date) {
            return null;
        }
        if (!date_fns_1.isValid(date)) {
            return { format: 'The date format is incorrect' };
        }
        else if (matchDayUtils_1.matchDayMax(date, disabledDays)) {
            return { maxDate: 'Date too far in the future' };
        }
        else if (matchDayUtils_1.matchDayMin(date, disabledDays)) {
            return { minDate: 'Date too far in the past' };
        }
        else if (matchDayUtils_1.matchDay(date, disabledDays)) {
            return { disabledDate: 'This date is not available' };
        }
        else {
            return null;
        }
    };
    DatePicker.prototype.handleScrollParent = function (e) {
        if (this.state.showPicker) {
            eventUtils_1.cancelEvent(e);
        }
    };
    DatePicker.prototype.handleKeydownScrollParent = function (e) {
        var scrollingKeys = [eventUtils_1.Keys.PAGE_UP, eventUtils_1.Keys.PAGE_DOWN, eventUtils_1.Keys.HOME, eventUtils_1.Keys.END, eventUtils_1.Keys.ARROW_UP, eventUtils_1.Keys.ARROW_DOWN];
        if (this.state.showPicker) {
            if (scrollingKeys.includes(e.key)) {
                eventUtils_1.cancelEvent(e);
            }
        }
    };
    DatePicker.prototype.handleDayClick = function (date, modifiers) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, format, onChange, onValidationChanged, locale, newDate, inputValue;
            return __generator(this, function (_b) {
                _a = this.props, format = _a.format, onChange = _a.onChange, onValidationChanged = _a.onValidationChanged;
                locale = this.state.locale;
                if (modifiers.disabled) {
                    return [2 /*return*/];
                }
                newDate = modifiers.selected ? undefined : date;
                inputValue = date_fns_1.format(date, format, { locale: locale });
                this.setState({
                    navigationDate: newDate,
                    inputValue: modifiers.selected ? undefined : inputValue,
                    showPicker: false,
                });
                if (onValidationChanged) {
                    onValidationChanged(this.computeError(newDate));
                }
                if (onChange) {
                    onChange({
                        target: { value: newDate },
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    DatePicker.prototype.handleInputChange = function (e) {
        var _a = this.props, format = _a.format, onChange = _a.onChange, onValidationChanged = _a.onValidationChanged;
        var locale = this.state.locale;
        var newValue = e.target.value;
        this.setState({ inputValue: newValue });
        var newDate = dateUtils_1.autocompleteDate(newValue, format, locale);
        if (newDate && date_fns_1.isValid(newDate)) {
            this.setState({ navigationDate: newDate });
        }
        if (onValidationChanged) {
            onValidationChanged(this.computeError(newDate));
        }
        if (onChange) {
            onChange({ target: { value: this.computeDate(newDate) } });
        }
    };
    DatePicker.prototype.handleKeyDownIcon = function (e) {
        var showPicker = this.state.showPicker;
        switch (e.key) {
            case eventUtils_1.Keys.TAB:
                if (!e.shiftKey && showPicker && this.refPicker) {
                    eventUtils_1.cancelEvent(e);
                    var elCell = this.refPicker.dayPicker.querySelector('.tk-daypicker-day[tabindex="0"]');
                    if (elCell) {
                        elCell.focus();
                    }
                }
                break;
            case eventUtils_1.Keys.SPACE:
            case eventUtils_1.Keys.SPACEBAR:
            case eventUtils_1.Keys.ENTER:
                eventUtils_1.cancelEvent(e);
                this.handleClickIcon();
                break;
            case eventUtils_1.Keys.ESC:
                eventUtils_1.cancelEvent(e);
                this.handleOnClose();
                break;
            default:
                break;
        }
    };
    DatePicker.prototype.handleKeyDownInput = function (e) {
        var showPicker = this.state.showPicker;
        switch (e.key) {
            case eventUtils_1.Keys.ENTER:
                eventUtils_1.cancelEvent(e);
                this.setState({ showPicker: !showPicker });
                break;
            case eventUtils_1.Keys.ESC:
                eventUtils_1.cancelEvent(e);
                this.setState({ showPicker: false });
                break;
            case eventUtils_1.Keys.TAB:
                this.setState({ showPicker: false });
                break;
            default:
                break;
        }
    };
    DatePicker.prototype.handleClickIcon = function () {
        var showPicker = this.state.showPicker;
        this.setState({ showPicker: !showPicker });
    };
    DatePicker.prototype.handleOnClose = function () {
        var refIcon = this.state.refIcon;
        this.setState({ showPicker: false });
        if (refIcon.current) {
            refIcon.current.focus();
        }
    };
    DatePicker.prototype.renderCalendar = function () {
        var _this = this;
        var _a = this.props, date = _a.date, disabledDays = _a.disabledDays, dir = _a.dir, highlightedDays = _a.highlightedDays, label = _a.label, labels = _a.labels, todayButton = _a.todayButton, menuPortalTarget = _a.menuPortalTarget, menuPortalStyles = _a.menuPortalStyles;
        var _b = this.state, locale = _b.locale, navigationDate = _b.navigationDate, showPicker = _b.showPicker;
        var portalStyles = menuPortalTarget ? menuPortalStyles : undefined;
        return (React.createElement(DatePickerContainer, { role: "tooltip", ref: this.setPopperElement, className: "DatePickerContainer", style: __assign({ display: showPicker ? 'block' : 'none' }, portalStyles) },
            React.createElement(DayPicker_1.default, { ref: function (el) { return (_this.refPicker = el); }, "aria-labelledby": label, selectedDays: this.computeDate(date), disabledDays: disabledDays, dir: dir, highlightedDays: highlightedDays, locale: locale, month: navigationDate, todayButton: todayButton, labels: labels, onDayClick: this.handleDayClick, onClose: this.handleOnClose })));
    };
    DatePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, disabled = _a.disabled, format = _a.format, label = _a.label, menuPortalTarget = _a.menuPortalTarget, name = _a.name, placeholder = _a.placeholder, tooltip = _a.tooltip, tooltipCloseLabel = _a.tooltipCloseLabel, showRequired = _a.showRequired, helperText = _a.helperText, onCopy = _a.onCopy, onCut = _a.onCut, onDrag = _a.onDrag, onFocus = _a.onFocus;
        var _b = this.state, inputValue = _b.inputValue, showPicker = _b.showPicker, refIcon = _b.refIcon;
        var textfieldProps = {
            id: id,
            disabled: disabled,
            helperText: helperText,
            label: label,
            name: name,
            placeholder: placeholder || format.toUpperCase(),
            tooltip: tooltip,
            tooltipCloseLabel: tooltipCloseLabel,
            showRequired: showRequired,
            onCopy: onCopy,
            onCut: onCut,
            onDrag: onDrag,
            onFocus: onFocus,
        };
        return (React.createElement("div", { className: 'tk-datepicker', ref: this.setRefContainer },
            React.createElement("div", { ref: this.setReferenceElement },
                React.createElement(TextField_1.default, __assign({}, textfieldProps, { className: classnames_1.default({
                        active: showPicker,
                    }), rightDecorators: React.createElement(FontIcon_1.default, { className: classnames_1.default('tk-input__right-decorators__clickable', {
                            active: showPicker,
                        }), disabled: disabled, iconName: 'calendar', forwardRef: refIcon, tabIndex: 0, onClick: function () { return _this.handleClickIcon(); }, onKeyDown: this.handleKeyDownIcon }), value: inputValue || '', onChange: this.handleInputChange, onClick: function () { return _this.setState({ showPicker: true }); }, onKeyDown: this.handleKeyDownInput }))),
            menuPortalTarget
                ? react_dom_1.createPortal(this.renderCalendar(), menuPortalTarget)
                : this.renderCalendar()));
    };
    DatePicker.defaultProps = {
        dir: 'ltr',
        format: 'MM-dd-yyyy',
        labels: {
            previousYear: 'Previous Year',
            nextYear: 'Next Year',
            previousMonth: 'Previous Month',
            nextMonth: 'Next Month',
        },
        placement: 'bottom',
        todayButton: 'Today',
        tooltipCloseLabel: 'Got it',
    };
    DatePicker.propTypes = {
        className: PropTypes.string,
        date: PropTypes.instanceOf(Date),
        format: PropTypes.string,
        dir: PropTypes.oneOf(['ltr', 'rtl']),
        disabled: PropTypes.bool,
        disabledDays: PropTypes.oneOfType(propTypesUtils_1.modifierPropTypes),
        highlightedDays: PropTypes.oneOfType(propTypesUtils_1.modifierPropTypes),
        initialMonth: PropTypes.instanceOf(Date),
        label: PropTypes.string,
        helperText: PropTypes.string,
        labels: PropTypes.exact({
            previousYear: PropTypes.string,
            previousMonth: PropTypes.string,
            nextYear: PropTypes.string,
            nextMonth: PropTypes.string,
        }),
        locale: PropTypes.string,
        name: PropTypes.string,
        onInit: PropTypes.func,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onValidationChanged: PropTypes.func,
        placeholder: PropTypes.string,
        placement: PropTypes.oneOf(['top', 'bottom', 'right', 'left']),
        todayButton: PropTypes.string,
        tooltip: PropTypes.string,
        tooltipCloseLabel: PropTypes.string,
        showRequired: PropTypes.bool,
        showOverlay: PropTypes.bool
    };
    return DatePicker;
}(react_1.Component));
exports.default = DatePicker;
var templateObject_1;
